export default {
	language: "Italiano",//意大利语
	sanqi: {
		zhoushi: "Scheda di tendenza",
		biaoti: "Operazioni in valuta crittografica su mercati altamente liquidi",
		xiangqing: "Anni di esperienza operativa hanno fornito agli utenti un ambiente commerciale ricco, flessibile, stabile, sicuro e affidabile",
		Global: "Struttura ecologica globale",
		Bank: "Sicurezza a livello bancario",
		Focus: "Focus sull'esperienza dell'utente",
		Convenient: "Facilitare le transazioni",
		project: "Sistema globale di espansione e gestione dei progetti, con centri commerciali locali di servizi in molti paesi",
		level: "Con il sistema portafogli a livello bancario, il controllo del rischio finanziario in tempo reale e l'autenticazione multi-dimensionale, il team di sicurezza finanziaria ha fornito garanzie multiple per la sicurezza del capitale negli ultimi dieci anni",
		polish: "lucidare con attenzione i dettagli per rendere l'UI e l'interazione più confortevole livello per livello, e la transazione può diventare un godimento visivo",
		Android: "Supporta il funzionamento di Android, IOS e web terminal, e controllo informazioni di mercato, mercati globali e transazioni in tempo reale in qualsiasi momento, ovunque",
		Download: "Scarica il cliente mobile e commercio liberamente in qualsiasi momento, ovunque",
		Palm: "Palm Trading",
		Trade: "Commercio in qualsiasi momento, ovunque",
		flow: "Esperienza mobile",
		Smooth: "L'operazione snella ti fa avere un'esperienza più piacevole",
		Real: "quotazione in tempo reale",
		time: "Aggiornamento in tempo reale, permette di cogliere la tendenza del mercato",
		Rapid: "Caricamento rapido",
		Experience: "Vivi velocemente e goditi quello che vuoi",
		Join: "Inizia il tuo viaggio contrattuale",
		Please: "Inserisci il tuo cellulare / e-mail nella casella di input qui sotto per registrare Azbit-usa",
		enter: "Inserisci la tua e-mail o il tuo numero di cellulare",
		Register: "registrazione",

		regulatory:'licenza regolamentare',
		regulatory_info:'Uncleblock è una società di servizi finanziari e monetari legalmente conforme sotto la supervisione del FINTRAC canadese (Canadian Financial Transaction and Report Analysis Center) e della US SEC (US Securities and Exchange Commission). Uncleblock rispetterà tutte le leggi e i regolamenti applicabili in ogni giurisdizione in cui opera in base al possesso di una licenza finanziaria. ',
		canada:'Canada (sotto supervisione)',
		certnum:'numero di certificato regolamentare',
		dateissue:'data di emissione',
		veriurl:'URL di verifica canadese',
		
		white_paper: 'carta bianca',
	},
	song: {
		low:'Inserisci la tua vecchia password',
	    jgsxf:"Riduzione delle spese di movimentazione per l'effettuazione degli ordini in base a contratti espressi",
	    jgbj:"Deduzione del capitale sotto contratto espresso",
	    jgks:"Ordine del contratto rapido, regolamento della perdita",
	    jgyl:"Chiusura rapida dell'ordine di contratto, regolamento di profitto",
	    htcz:"Ricarica di fondo",
	    htshcz:"Ricarica di audit di fondo",
	    bbhr:"Trasferimento nel conto di valuta",
	    bbhc:"Trasferimento del conto di valuta",
	    pccl:"Smaltimento dei fondi di posizione chiusa",
	    gmsxf:"Riduzione della tassa di movimentazione per la vendita collegata",
	    ggsxf:"Operazioni di leva finanziaria, escluse le spese di movimentazione",
		ggbzj:"Operazioni soggette a leva, al netto del margine",
	    gbdj:"Presentazione del blocco di acquisto in attesa",
	    gbkc:"Sottomessa deduzione di acquisto collegata",
	    gsdj:"Sottoquotazione congelantesi",
	    gskc:"Sottomessa deduzione delle vendite collegate",
	    tbsbjs:"Rimborso non riuscito, riduzione del saldo di chiusura",
	    tbsbch:"Rimborso della valuta, saldo bloccato ritirato",
	    tbcg:"Ritiro riuscito",
	    gyf:"Scambio equo, addebito di una tassa di pernottamento",
		gghr:"Trasferimento dal conto di leva",
	    gghc:"Trasferimento dal conto di leva",
	    tbdj:"Domanda di ritiro della valuta e saldo di congelamento",
	    tbkc:"Applicare per il saldo di deduzione monetaria",
	    mhxh:"Consumo di scatola chiusa",
	    mhhq:"Acquisizione della scatola cieca",
	    msxf:"Riduzione della tassa di movimentazione per il collocamento d'ordine del secondo contratto",
	    mbj:"Eliminare il principale al momento dell'ordinazione",
	    mks:"Secondo ordine contrattuale, regolamento perdite",
	    myl:"Chiusura del secondo contratto, regolamento di profitto",
	    mhr:"Trasferimento del secondo conto contrattuale in",
	    mhc:"Trasferimento del secondo conto contrattuale",
	    sfsczj:"Estrazione di serrature per aumentare le attività disponibili",
	    sfsckc:"Estrazione delle attività di deposito chiuso a rilascio",
	    sczj:"L'estrazione di magazzino chiuso aumenta le attività congelate",
	    sckc:"Chiusura delle attività estrattive disponibili",
	    scsy:"Chiusura delle entrate minerarie disponibili",
	    ahtcz:"Osservazioni di ricarica di fondo",
	    xcbx:"Quick contract order regolamento finale, nessuna assicurazione efficace, e il capitale rimane immutato",
		bbjx:"transazione di valuta: l'utente annulla l'impiccagione e lo sblocco",
		bbth:"transazione di valuta: l'utente annulla l'acquisto e i rendimenti impiccanti",
		wtcd_t:"Annullamento della Commissione e restituzione della tassa di movimentazione",
		wtcd_b:"Annullamento dell'accettazione e restituzione del deposito",
		bxju_p:"Insurance terminazione e importo della compensazione",
		bxju_s:"Cessazione dell'assicurazione, deduzione dell'importo assicurato",
		bxju_b:"Cessazione dell'assicurazione e deduzione dell'importo dell'assicurazione",
	},
	iesan: {
		li_a: 'Concentrati e lascia il resto a noi.',
		li_b: "Automatizzata analisi di investimento - in base alla posizione di chiusura e estrazione di Azbit-usa, può personalizzare le idee di trading per le coppie principali di valuta di trading degli investitori, e le impostazioni di conto altamente autonome - personalizzare la colonna di confronto di ritiro del fondo, colonna di confronto di posizione e colonna di confronto di preallarme a seconda dei diversi tipi di clienti. Prenditi cura dei commercianti con diversa tolleranza al rischio sul mercato. Prestito in valuta di riserva - la piattaforma fornisce prestiti in valuta di riserva per l'estrazione di deposito chiuso. È possibile ottenere il finanziamento di piattaforma di prestito valuta applicando solo se le attività digitali del conto raggiungono 50% del limite di prenotazione.",
		zuidi: 'Quantità iniziale',
		b_liord: "Orden de caja ciega",
		b_zhomg: "Ganador de la Caja ciega",
		b_xiaohao: "Consumo",
		b_mangheli: "Bolsa de regalo de caja ciega",
		b_qingsong: "Descubra fácilmente la bolsa de regalo super grande",
		b_kaiqi: "Abrir caja ciega",
		b_xuyao: "Abrir la Caja ciega actual requiere",
		b_dangqian: "Saldo actual",
		b_quxiao: "Cancelar",
		b_ok: "Determinar",
		b_cuocang: "Ganar dinero con cerradura",
		b_dindan: "Orden de caja ciega",
		b_genduo: "Cargar más",
		b_wabao: "Excavar un tesoro",
		b_jiandan: "La minería es más fácil y fácil de recompensar",
		b_cung: "Ganar dinero con cerradura",
		b_shouyi: "Ingresos totales",
		b_zhiyao: "Cantidad prometida",
		b_qianbao: "Saldo de la cartera",
		b_goumai: "Comprar",
		b_zhjuanbi: "Ganar dinero con cerradura",
		b_num: "Número de monedas depositadas",
		b_yuji: "Ingresos totales previstos",
		b_jin: "Cerca",
		b_rinianhua: "Anualización diaria de referencia",
		b_suochang: "Período de cierre",
		b_gtou: "Comprar",
		b_jilu: "Registro de bloqueo",
		b_biaohuao: "Número de proyecto",
		b_bizhong: "Moneda",
		b_shuliang: "Número de monedas depositadas",
		b_jixi: "Intereses totales",
		b_suocang: "Tiempo de cierre",
		b_shijan: "Fecha de vencimiento",
		b_zhuangtai: "Estado",
		b_jinxin: "En curso",
		b_jieshu: "Terminado",
		b_zhenqui: "Introduzca la cantidad correcta",
		b_tian: "Días",
		b_mei: "No más",
		b_maghe: "Caja ciega",
		b_wakuang: 'Bloqueo de minas',
		levermin: "Cantidad inferior al mínimo"
	},
	chongbi: {
		zaixian:"Servizio clienti online",
		fuzhi:"Copia etichetta",
		huazhuan:"Trasferimento",
		bizhong:"Valuta",
		keyong:"Bilancio disponibile",
		cong:"Da",
		zhi:"A",
		num:"Quantità di trasferimento",
		shuru:"Inserisci la quantità di trasferimento",
		whatsapp:"Inserisci il numero di conto WhatsApp",
		youxiang:"Mailbox",
		superior: "I miei subordinati",
		tiem: "Tempo",
		tit: "Il mio membro",
		group: "Numero di squadre",
		not: "Nessun membro",
		qukuai: "Scuola Blockchain",
		fabi: "Operazione di valuta legale",
		gonggao: "AnnAzbit-usaio",
		xitong: "Articolo di sistema",
		yonghu: "Supporto utente",
		bangzhu: "Aiuto centro",
		shouyi: "Regole delle entrate",
		xinwen: "News Center",
		xinshou: "Aiuto nel romanzo",
		jiaoyi: "Regole di transazione",
		kuaixun: "Newsletter",
	},
	// 导航
	header: {
		wakuang: "Estrazione di magazzino chiusa",
		miaohy: "Contratto di velocità",
		home: "Home page",
		markets: "Mercato",
		fiat: "Operazione di valuta legale",
		c2c: "C2C transazione",
		exchange: "Operazione di valuta",
		lever: "Operazione contrattuale",
		myshop: "Il mio negozio",
		assets: "I miei beni",
		help: "Aiuto centro",
		login: "Login",
		sign: "Registro",
		accountSet: "Impostazioni del conto",
		tradeLog: "Registro di transazione",
		receiveSet: "Impostazioni della collezione",
		identify: "Autenticazione dell'identità",
		jchange: "Cambio di valuta",
		logout: "Esci fuori",
		themedark: "Modalita'notturna",
		themeday: "Modalita'diurna",
	},
	// 登录注册
	lg: {
		login: "Login",
		register: "Registro",
	},
	// 首页
	home: {
		vol: "24h volume",
		c01: "La principale piattaforma di scambio di asset digitali del mondo",
		c02: "Fornire servizi di trading e gestione di asset digitali sicuri e affidabili a milioni di utenti in più di 130 paesi in tutto il mondo",
		c03: "Sicuro e affidabile",
		c04: "5 anni di esperienza nei servizi finanziari di attività digitali",
		c05: "Architettura distribuita professionale e sistema di attacco DDoS",
		c06: "Struttura ecologica globale",
		c07: "Diversi paesi hanno istituito centri commerciali localizzati",
		c08: "Costruire un ecosistema a catena di blocchi che integri molteplici forme di business",
		c09: "Prima il cliente",
		c10: "Stabilire un meccanismo di compensazione anticipata",
		c11: "Istituzione di un fondo di protezione degli investitori",
		c12: "Interpiattaforma terminale transazione in qualsiasi momento, ovunque",
		c13: "Coprire più piattaforme di IOS, Android e finestre, supportando funzioni a pieno servizio",
		sweep: "Download di scansione codice",
		android: "Androide",
		pinput: "Inserisci la tua e-mail o il tuo numero di cellulare",
		atrade: "Registrare un account di e-x per avviare il viaggio di transazione"
	},
	// 底部
	foo: {
		about: "Su di noi",
		support: "Supporto utente",
		contact: "Contattaci",
		qq: "Servizio clienti QQ",
		email: "casella di contatto",
	},
	// 行情
	market: {
		exchange: "Valuta",
		selfmarket: "Opzionale",
		allmarket: "Tutte le citazioni",
		symbol: "Coppia di transazione",
		newprice: "Ultimo prezzo",
		change: "Incremento",
		highprice: "Top price",
		lowprice: "Prezzo più basso",
		vol: "24h volume",
	},
	// 公共交易
	td: {
		purchase: "Prezzo d'acquisto",
		transaction: "Prezzo di transazione",
		service: "Costi di gestione",
		profit: "Profitto e perdita",
		buy: "Acquisto",
		sell: "Vendita",
		currency: "Valuta",
		num: "Quantità",
		time: "Tempo",
		limit: "Limiti",
		price: "Prezzo unitario",
		method: "Metodo di pagamento",
		total: "Totale",
		inwant: "Per favore entra a",
		do: "Operazione",
		more: "Carica di più",
		nomore: "Basta così",
		nodata: "Nessun dato",
		trade: "Transazione",
		buynum: "Quantità di acquisto",
		sellout: "Vendi",
		buyin: "Acquista",
		all: "Tutti",
		allbuy: "Compra tutto",
		allsell: "Vendi tutti",
		buytotal: "Inserisci l'importo totale da acquistare",
		selltotal: "Inserisci l'importo totale da vendere",
		buyallnum: "Inserisci la quantità che vuoi comprare",
		sellallnum: "Inserire la quantità da vendere",
		tradeTotal: "Importo totale della transazione",
		doceil: "Annulla automaticamente in pochi secondi",
		place: "Ordine",
		waitpay: "Pagamento in attesa",
		paycode: "Codice di pagamento",
		finished: "Completato",
		ceiled: "Annullato",
		payed: "Paid",
		nofinish: "Incompleta",
		buyer: "Acquirente",
		seller: "Venditore",
		callWay: "Informazioni di contatto",
		placeTime: "Ora dell'ordine",
		renum: "Numero di riferimento",
		canceil: "Annulla",
		confirm: "Conferma",
		pwd: "Inserisci password di transazione",
		coincode: "Unità di valuta",
		pcoin: "Si prega di selezionare un'unit à monetaria"
	},
	// 法币交易
	fat: {
		// LegalPayDetail
		orderLog: "Registrazione dell'ordine",
		fatdLog: "Operazioni in valuta legale",
		shoper: "Merchant",
		faLog: "Operazioni in valuta legale",
		tdType: "Tipo di transazione",
		odStatus: "Stato dell'ordine",
		pwaitPay: "Per favore aspetta che il compratore paghi",
		odFinish: "Ordine completato",
		odCeil: "Ordine annullato",
		odPay: "Pagato, controlla attentamente le informazioni di pagamento",
		tdCeil: "Annulla transazione",
		pCeil: "Se hai pagato il venditore, non annullare la transazione",
		paySure: "Conferma di pagamento",
		pdopay: "Confermate di aver pagato il venditore",
		badClick: "Il click malizioso bloccherà direttamente il conto",
		receivePay: "conferma della collezione",
		payReceive: "Conferma che l'acquirente ti ha pagato",
		receivePays: "Conferma ricevuta",
		// LegalPay
		payPlease: "Per favore paga",
		tdPrice: "Prezzo unitario di transazione",
		tdNum: "Quantità di transazione",
		payinfo: "Informazioni sui pagamenti",
		banknum: "Conto bancario",
		realName: "Nome vero",
		shoperZname: "Sottoramo mercantile",
		shoperNum: "Conto commerciale",
		odCeil: "Annulla ordine",
		imPay: "Ho pagato, click OK",
		// LegalSeller
		register_time: "Ora di registrazione",
		odtotal: "Elenco dell'assemblea",
		odmonth: "30° ordine di giorno",
		odfinish: "Foglio di completamento",
		odrate: "Tasto di completamento",
		submit: "Pubblica",
		phone: "Telefono cellulare",
		mysell: "La mia vendita",
		mybuy: "Il mio acquisto",
		realAuth: "Autenticazione del vero nome",
		advAuth: "Certificazione avanzata",
		linebuy: "Acquista online",
		linesell: "Vendi online",
		tipPay: "Si prega di contattare il commerciante per il pagamento entro un 24 ore. Se supera le ore 24, sarà automaticamente cancellato",
		notlow: "Non può essere inferiore al minimo",
		nothigh: "Il limite massimo non può essere superato",
		notnum: "Non è possibile superare la quantità massima",
		// LegalShopDetail
		type: "Tipo",
		status: "Status",
		seeOrder: "Ordine di vista",
		withdraw: "Ritiro",
		abnormal: "Eccezione",
		lowershelf: "Fuori dallo scaffale",
		protection: "Diritti di difesa",
		apply: "Domanda di tutela dei diritti",
		psType: "Per favore seleziona tipo",
		pselect: "Per favore seleziona",
		alipay: "Alipay.",
		wechat: "Wechat",
		bank: "Carta bancaria",
		minNum: "Volume minimo della transazione",
		maxNum: "Volume massimo della transazione",
		wantBuy: "Acquista",
		pnums: "Inserisci la quantità",
		pmin: "Inserisci il volume minimo di transazione",
		pmax: "Inserisci il volume massimo di transazione",
		pnot: "Il volume massimo della transazione non può essere inferiore al volume minimo della transazione",
		// MyLegalShops
		myshops: "Il mio negozio",
		name: "Nome",
		fiatSub: "moneta legale",
		shoper_balance: "Bilancio commerciale",
		enterShop: "Entra nel negozio",
		// shop_legal_pay_detail
		payedWait: "Pagato, in attesa di conferma dopo la verifica",
		yes: "Sì",
		no: "No",
		sd: "Blocca l'equilibrio",
		journal: "Bilancio",
		business: "Merchant",
		user: "Utente",
		backdone: "Ritirato",
		busbalance: "Bilancio commerciale",
		userbalance: "Bilancio utente",
	},
	ctc: {
		ctc: "C2C",
		myRelease: "Il mio C2C",
		myTrade: "Commercio C2C I",
		and: "Sì",
		balance: "Equilibrio",
		buynum: "Volume di acquisto",
		sellnum: "Volume delle vendite",
		bankTransfer: "Trasferimento bancario",
		payim: "Deve essere pagato di persona",
		pbuyNum: "Inserisci la quantità d'acquisto",
		pprice: "Inserite il prezzo unitario",
		payway: "Selezionare il metodo di pagamento",
		psellNum: "Inserire la quantità venduta",
		suerePlace: "Confermare l'ordine?",
		detail: "Dettagli",
		payinfo: "Informazioni sui pagamenti",
		Payee: "Payee",
		total: "Totale",
		name: "Nome",
		cardnum: "Numero di carta",
		receivePay: "Conferma ricevuta",
		ceilConfirm: "Conferma di annullare la transazione?",
		paySeller: "Confermate che avete pagato il venditore. Il click malizioso bloccherà il conto",
		payBuyer: "Si prega di confermare di aver acquistato informazioni sul pagamento a casa",
		account: "Numero di conto",
		sellerPay: "Per favore conferma che l'acquirente ti ha pagato?",
		payattion: "Si prega di pagare il venditore il prima possibile dopo che il pagamento è confermato. Il clic malizioso bloccherà direttamente il conto",
		log: "C2C ordine completato",
	},
	// 合约
	lever: {
		purchase: "Prezzo d'acquisto",
		Expected: "Risultato stimato",
		countdown: "Conteggio",
		second: "Secondi",
		jiaoyinum: "Quantità",
		houmaicg: "Acquisto riuscito",
		nowentrust: "Delegato attuale",
		hisentrust: "Delegazione storica",
		lvchi: "Posizione contrattuale",
		all: "Tutti",
		or: "O",
		gotrade: "Inizio transazione",
		tdrecord: "Transazione",
		dealed: "Chiuso",
		notdeal: "Nessun accordo",
		loading: "Caricamento",
		entotal: "Importo delegato totale",
		canuse: "Disponibile",
		std: "transazione di mercato",
		xtd: "Limiti di scambio",
		pprice: "Per favore inserisci il prezzo",
		phand: "Inserisci la quantità d'acquisto",
		phandsell: "Si prega di immettere quantità in vendita",
		pwd: "Password",
		ppwd: "Inserisci password di transazione",
		psw: "Password di transazione",
		equal: "Uguale a",
		times: "Tempi",
		timed: "Multiple",
		hand: "Mano",
		miao: "s",
		miaos: "Secondi",
		hands: "Numero di mani",
		ptimes: "Per favore seleziona multipli",
		phands: "Per favore seleziona il numero di mani",
		contractVal: "Valore di mercato contrattuale",
		bail: "deposito di sicurezza",
		canBail: "margine disponibile",
		charge: "Spese di transazione",
		domore: "Buy (long)",
		doshort: "Vendi (corto)",
		dmore: "Lunga",
		dshort: "Breve",
		sureOd: "Conferma l'ordine",
		noless: "Il numero di mani non può essere inferiore a",
		nomore: "Il numero di mani non può essere più alto di",
		tdnum: "Volume delle transazioni",
		risk: "Tasso di rischio",
		allloss: "Utile e perdite totali",
		onehouse: "Un clic per chiudere la posizione",
		type: "Tipo",
		entrustPrice: "Prezzo della Commissione",
		openPrice: "Prezzo d'apertura",
		nowPrice: "Prezzo attuale",
		styPrice: "Prezzo di arresto del profitto",
		stsPrice: "Stop perdita prezzo",
		openTime: "Orario di apertura",
		closeTime: "Tempo di chiusura",
		rate: "Costi di gestione",
		nightFee: "Tassa di notte",
		loss: "Profitto e perdita",
		setloss: "Imposta profitti e perdite",
		expectProfit: "Utili attesi",
		expectLoss: "Perdita prevista",
		allClose: "Chiudete tutte le posizioni",
		moreClose: "Solo ordini piatti multipli",
		nullClose: "Solo ordini vuoti",
		sureClose: "Conferma posizione di chiusura?",
		thanZearo: "Il valore impostato deve essere superiore a 0",
		listin: "Pendente",
		tdin: "In transazione",
		closein: "Posizione di chiusura",
		closed: "Posizione chiusa",
		revoked: "Annullato",
		revokeOrder: "Sei sicuro di cancellare l'ordine?",
		ping: "Chiudi la porta",
		revoke: "Cancellazione",
		sureping: "Sei sicuro di chiudere la posizione?",
		thanzone: "Il valore impostato deve essere superiore a 0",

		profitability: 'Redditività',
		profit_: 'profitto',
	},
	// 币币
	cuy: {
		direction: "Direzione",
		total: "Totale",
		price: "Prezzo",
		sell: "Vendi",
		buy: "Acquista",
		allStation: "Intero sito transazione",
		buyPrice: "Prezzo a prezzo",
		buynum: "Volume di acquisto",
		sellPrice: "Prezzo di vendita",
		sellnum: "Volume delle vendite",
		tdPrice: "Importo della transazione",
		or: "O",
		tdStart: "Inizio transazione",
		pbPrice: "Per favore inserisci il prezzo d'acquisto",
		pbNum: "Inserisci la quantità d'acquisto",
		psPrice: "Per favore inserisci il prezzo di vendita",
		psNum: "Inserire il volume delle vendite",
		fixPrice: "Limiti di scambio",
		Mtrans: "transazione di mercato",
		available: "Disponibile",
		revoke: "Annulla",
		loading: "Caricamento",
		confirmCancel: "Sei sicuro di voler annullare?",
		confirm: "OK",
		cancel: "Annulla",
		nomore: "Niente più dati",
		evelPrice: "Prezzo medio di transazione"
	},
	// 资产
	asset: {
		text1:"Indirizzo di ricarica",
		text2:"Inserisci l'indirizzo di ricarica",
		text3:"Quantità di ricarica valutaria",
		text4:"Inserisci la quantità di carica",
		text5:"Inviare informazioni di ricarica",
		miao_account: "Conto del contratto di velocità",
		assets: "Attività",
		currency_account: "Conto di valuta",
		lever_account: "Conto contrattuale",
		fince_account: "Conto di valuta legale",
		change_account: "Conto commerciale",
		assets_hua: "Trasferimento del Fondo",
		all_assets: "conversione totale delle attività",
		currency: "Valuta",
		canuse: "Disponibile",
		frezz: "Fermo!",
		conversion: "Equivalente",
		charging: "Ricaricare",
		withdraw: "Ritiro",
		address_bind: "Indirizzo di ritiro vincolato",
		address_withdraw: "Gestione dell'indirizzo di ritiro della valuta",

		record: "Registrazione",
		address_charge: "Indirizzo di ricarica",
		address_width: "Indirizzo di ritiro",
		copy: "Copia",
		ercode: "Codice QR",
		reminder: "Consigli caldi",
		notcharge: "Non ricaricare asset non USDT all'indirizzo sopra indicato, altrimenti gli asset non verranno recuperati",
		support: "Recensione supporta solo il semplice metodo di invio. Recensione utilizzando altri metodi (inviare tutti) non può essere postato temporaneamente. Si prega di capire.",
		minnum: "Quantità minima di ritiro della valuta",
		ratenum: "Costi di gestione",
		havenum: "Quantità ricevuta",
		from: "Da",
		to: "A",
		transfer: "Trasferimento",
		tfnum: "Quantità di trasferimento",
		ptfnum: "Inserisci il minimo",
		dtfnum: "Numero di trasferimenti",
		canbalance: "Bilancio disponibile",
		sureConfirm: "Conferma trasferimento",
		moneyRecord: "Conti finanziari",
		pNum: "Inserisci la quantità di trasferimento",
		leverUse: "Conto contrattuale disponibile",
		legalUse: "Conto di valuta legale disponibile",
		changeUse: "Conto di transazione disponibile",
		look: "Vista",
		chargeRecord: "Registrazione carica",
		status: "Stato di localizzazione",
		noopen: "Questa funzione non è aperta",
		enterAdderses: "Per favore inserisci l'indirizzo di ritiro",
		enterNum: "Inserire il quantitativo di prelievo",
		lessMin: "La quantità di prelievo registrata è inferiore al valore minimo",
		tips01: "Non ricaricare altre attività al suddetto indirizzo, altrimenti le attività non saranno recuperate.",
		tips02: "Recensione supporta solo il semplice metodo di invio. Recensione utilizzando altri metodi (inviare tutti) non può essere postato temporaneamente. Si prega di capire.",
		beizhu: "Osservazioni",
		pbeizhu: "Per favore inserisci commenti",
		add: "Aggiungi",
		addressList: "Elenco degli indirizzi",
		delete: "Elimina",
		norec: "Nessun record",
		selectCurrency: "Per favore seleziona una valuta",
		chainType: "Tipo di catena"
	},
	// 账户设置
	set: {
		mycode2: "Il mio codice d'autorizzazione",
		copycode2: "Codice dell'autorizzazione di copia",
		uaccont: "Livello di sicurezza del tuo conto:",
		strong: "Forte",
		middle: "Media",
		weak: "Debole",
		min: "Basso",
		heigh: "Alti",
		complete: "Migliorare più informazioni per garantire la sicurezza del conto",
		mycode: "Il mio codice d'invito",
		copycode: "Copia codice d'invito",
		bindphone: "Bind phone",
		bindemail: "Bind mailbox",
		loginpwd: "password di accesso",
		noBind: "Senza restrizioni",
		binds: "Bind",
		bind: "Sforzo",
		binded: "Confine",
		net: "C'è il rischio di furto del tuo account internet. Si raccomanda di cambiare regolarmente la tua password per proteggere la sicurezza del tuo account.",
		reset: "Modifica",
		setPsw: "Imposta la password della transazione per garantire la sicurezza della transazione.",
		goSet: "Per impostare",
		bindAccount: "Conto di cambio vincolato",
		duihuan: "Conto vincolante per il rimborso dei punti",
		copysuccess: "Copia riuscita",
		copyfail: "Copia fallita",
		recopy: "Copia di nuovo",
		account: "Conto",
		detail: "Dettagli",
		val: "Importo",
		forgetPsw: "Ho dimenticato la password",
		code: "Codice di verifica",
		getCode: "Ottenere codice di verifica",
		setPsw: "Imposta la password",
		enterPsw: "Inserisci la password",
		pswFalse: "Le password inserite due volte sono incoerenti",
		enterPswagain: "Inserisci di nuovo la password",
		jsetPsw: "Imposta password di transazione",
		jenterPsw: "Inserisci password di transazione",
		jenterPswagain: "Inserisci di nuovo la password della transazione",
		enterAccount: "Inserisci il numero di conto",
		enterCode: "Inserire codice di verifica",
		accountFalse: "Il cellulare o l'account email che hai inserito non rispetta le regole!",
		second: "Secondi",
		sendCode: "Invia codice di verifica",
		sendsucc: "Inviato con successo",
		enterPswTwo: "Per favore inserisci la tua password due volte",
		rest: "Restando",
		yes: "Sì",
		no: "No",
		yorn: "Imposta password di transazione",
	},
	// 身份认证
	auth: {
		identity: "Autenticazione dell'identità",
		name: "Nome",
		idcard: "Carta d'identità",
		upimg: "Per favore carica la tua foto identificativa. La prima è la parte anteriore, la seconda è la parte posteriore, e la terza è la parte anteriore della tua foto identificativa tenuta a mano.",
		submit: "Inviare",
		auditing: "Essere approvato...",
		certified: "Certificato!",
		pname: "Per favore inserisci un nome",
		pidcard: "Inserisci il numero identificativo",
		pimg: "Per favore carica la foto del certificato!",
	},
	// 收款方式
	seting: {
		pmethod: "Metodo di raccolta",
		truename: "Nome vero",
		opening: "Nome della banca di deposito",
		bank: "Numero della carta bancaria",
		alipay: "Alipay account",
		wename: "nickname Webchat",
		wechat: "Conto di Webchat",
		pname: "Per favore inserisci il tuo vero nome",
		popen: "Per favore inserisci il nome della banca di deposito",
		pcard: "Per favore inserisci il numero della carta",
		palipay: "Inserisci il numero di conto Alipay",
		pwname: "Per favore inserisci il nick wechat",
		pwaccount: "Per favore inserisci account wechat",
		pimg1: "Codice di raccolta di Webchat",
		pimg2: "Codice di raccolta Alipay"
	},
	// 帮助中心
	news: {
		seeall: "Visualizza tutto",
		helpcenter: "Aiuto centro",
		back: "Indietro",
		gonggao: "AnnAzbit-usaio"
	},
	//登录
	login: {
		welcome: "Benvenuti al login",
		phoneLogin: "Accesso mobile",
		emailLogin: "Mailbox login",
		account: "Numero di conto",
		psw: "Password",
		login: "Login",
		nouser: "Non ancora un utente di e-x?",
		goRegister: "Registratevi ora e cominciate a commerciare sulla piattaforma di trading digitale leader mondiale.",
		registerFree: "Registrazione gratuita",
		psw6: "La password non può essere meno di sei cifre"
	},
	register: {
		register: "Registro",
		phoneRegister: "Registrazione mobile",
		emailRegister: "Registrazione postale",
		country: "Nazionalità",
		enterPhone: "Inserisci il tuo numero di cellulare",
		enterEmail: "Per favore inserisci la cassetta",
		psw16: "Password tra i bit 6-16",
		inviteCode: "Codice di invito",
		sel: "Obbligato",
		sel2: "Non richiesto",
		read: "Ho letto e sono d'accordo",
		xieyi: "Accordo utente",
		tips01: "Le informazioni sulla nazionalità non possono essere modificate dopo la registrazione. Per favore sceglietele sinceramente.",
		tips02: "La posta di verifica può essere mal giudicata come spam. Per favore controlla.",
		tips03: "Per favore mantieni il tuo account e login password correttamente.",
		tips04: "Non usare la stessa password di accesso di altri siti web.",
		emailFalse: "La cassetta che hai inserito non risponde alle regole"
	},
	// 积分兑换
	jc: {
		title: "JC beau piattaforma per lo scambio di beni digitali",
		balance: "Equilibrio",
		cannum: "Numero di JCS disponibile",
		new: "Ultimo prezzo",
		exnum: "Quantità di scambio",
		pnum: "Inserisci la quantità di JC",
		canex: "Numero di corteggiatore decappottabile",
		exnow: "Redeem ora",
		record: "Scambio di record",
		exprice: "Prezzo di cambio",
		extime: "Tempo di scambio",
		not: "Punti insufficienti disponibili",
		usenum: "Numero di JCS utilizzato",
		out: "Uscita",
		gotd: "Scambio"

	}

}



// WEBPACK FOOTER //
// ./src/lang/ita.js